import React from "react";
import PropTypes from "prop-types";

import styles from "./MainApp.atoms.Loader.module.scss";
//state: enabled, disabled, waiting, temporary
export class Loader extends React.Component {
  render() {
    const { title } = this.props;

    return (
      <div
        className={styles["loader-container"]}
        style={{ backgroundColor: this.props.backgroundColor || undefined }}
      >
        <div className={styles["content-wrapper"]}>
          <div className={styles["spinner"]}>
            <div className={styles["loadingio-spinner-rolling-lktnp05eknk"]}>
              <div className={styles["ldio-oktnutaa7e"]}>
                <div></div>
              </div>
            </div>
          </div>
          <div className={styles["title"]}>
            <div>{title}</div>
          </div>
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default Loader;
